(function initComparisonProductDrawer() {
  if (customElements.get('comparison-product-drawer')) return;

  const DrawerBase = customElements.get('x-drawer');
  if (!DrawerBase) {
    if (customElements.whenDefined) {
      customElements.whenDefined('x-drawer').then(initComparisonProductDrawer);
    }
    return;
  }

  class ComparisonProductDrawer extends DrawerBase {
    get openFrom() {
      return window.matchMedia(`${window.themeVariables.breakpoints['sm-max']}`).matches ? 'top' : this.getAttribute('open-from') || 'right';
    }

    show(animate) {
      if (this.open) {
        return Promise.resolve();
      }

      document.querySelectorAll('comparison-product-drawer[data-comparison-drawer][open]').forEach((drawer) => {
        if (drawer !== this && typeof drawer.hide === 'function') {
          drawer.hide();
        }
      });

      return super.show(animate);
    }
  }

  customElements.define('comparison-product-drawer', ComparisonProductDrawer);
})();

const BK_MEDIA_COMPARISON_BUNDLE_STORAGE_KEY = 'bk-media-comparison-bundle-variants';
const BK_MEDIA_COMPARISON_SPARSET_SECTION_KEY = 'bk-media-comparison-sparset-section-id';

if (!customElements.get('bk-media-product-comparison')) {
  class BkMediaProductComparison extends HTMLElement {
    connectedCallback() {
      this.productsData = this.loadProductsData();
      this.syncRows = this.syncRows.bind(this);
      this.onSelectorClick = this.onSelectorClick.bind(this);
      this.onDrawerTriggerClick = this.onDrawerTriggerClick.bind(this);
      this.onDrawerSearch = this.onDrawerSearch.bind(this);
      this.onDrawerHide = this.onDrawerHide.bind(this);
      this.onDrawerShow = this.onDrawerShow.bind(this);
      this.onDrawerFooterClick = this.onDrawerFooterClick.bind(this);
      this.onBundleClick = this.onBundleClick.bind(this);
      this.onCriteriaToggle = this.onCriteriaToggle.bind(this);
      this.onColumnControlClick = this.onColumnControlClick.bind(this);
      this.onAtcSubmit = this.onAtcSubmit.bind(this);
      this.onBundlePromptClick = this.onBundlePromptClick.bind(this);
      this.onBundlePromptKeydown = this.onBundlePromptKeydown.bind(this);
      this.onGalleryTriggerClick = this.onGalleryTriggerClick.bind(this);

      this.drawerSelectedIds = [];
      this.hasUserSelection = false;
      this.selectorDefaultText = this.dataset.selectorDefaultText || 'Wähle deine Produkte';
      this.emptyStateHintDefault = this.dataset.emptyStateHint || 'Wähle mindestens 2 Produkte, um den Vergleich zu starten.';

      this.pendingAtcForm = null;
      this.bundlePrompt = this.querySelector('[data-comparison-bundle-prompt]');

      this.bundleBar = this.querySelector('[data-comparison-bundle-bar]');
      this.bundlePlacement = this.querySelector('[data-comparison-bundle-placement]');
      this.bundleButton = this.querySelector('[data-comparison-bundle-action]');
      this.bundleSavingsRow = this.querySelector('[data-comparison-bundle-savings]');
      this.bundleSavingsAmount = this.querySelector('[data-comparison-bundle-savings-amount]');
      this.bundlePricesEl = this.querySelector('[data-comparison-bundle-prices]');
      this.bundleSalePriceEl = this.querySelector('[data-comparison-bundle-sale-price]');
      this.bundleComparePriceEl = this.querySelector('[data-comparison-bundle-compare-price]');
      this.bundleButton?.addEventListener('click', this.onBundleClick);

      this.capturePreviewBlockProducts();
      this.setActiveColumnCount(this.getInitialColumnCount());
      this.updatePreviewMode();
      this.updateEmptyStateUI();
      this.syncRows();
      this.initComparisonDrawers();
      this.initCriteriaFilter();
      this.updateBundleButton();
      setTimeout(() => this.updateBundleButton(), 300);
      this.updateColumnControls();
      document.addEventListener('shopify:section:load', this.onRelatedSectionLoad);
      document.addEventListener('click', this.onDrawerTriggerClick, true);
      this.addEventListener('submit', this.onAtcSubmit, true);
      document.addEventListener('click', this.onColumnControlClick);
      document.addEventListener('click', this.onBundlePromptClick);
      document.addEventListener('keydown', this.onBundlePromptKeydown);
      this.addEventListener('click', this.onGalleryTriggerClick);
      document.addEventListener('click', this.onSelectorClick);
      document.addEventListener('click', this.onDrawerFooterClick);
      document.addEventListener('input', this.onDrawerSearch);
      document.addEventListener('reset', this.onDrawerSearch, true);
      this.onResize = this.onResize || (() => {
        this.syncRows();
      });

      window.addEventListener('resize', this.onResize);
      document.addEventListener('shopify:section:load', this.onSectionLoad);

      this.resizeObserver = new ResizeObserver(() => {
        requestAnimationFrame(() => this.syncRows());
      });
      this.resizeObserver.observe(this);

      this.querySelectorAll('img').forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', this.syncRows, { once: true });
        }
      });

      this.initProductsScroll();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDrawerTriggerClick, true);
      this.removeEventListener('submit', this.onAtcSubmit, true);
      document.removeEventListener('click', this.onColumnControlClick);
      document.removeEventListener('click', this.onBundlePromptClick);
      document.removeEventListener('keydown', this.onBundlePromptKeydown);
      document.removeEventListener('click', this.onSelectorClick);
      this.removeEventListener('click', this.onGalleryTriggerClick);
      document.removeEventListener('click', this.onDrawerFooterClick);
      document.removeEventListener('input', this.onDrawerSearch);
      document.removeEventListener('reset', this.onDrawerSearch, true);
      this.bundleButton?.removeEventListener('click', this.onBundleClick);
      document.removeEventListener('shopify:section:load', this.onRelatedSectionLoad);
      this.getComparisonDrawers().forEach((drawer) => {
        drawer.removeEventListener('dialog:after-hide', this.onDrawerHide);
      });
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      this.resizeObserver?.disconnect();
      this._productsScrollResizeObserver?.disconnect();
      if (this.swapConfirmationTimeout) clearTimeout(this.swapConfirmationTimeout);
    }

    onSectionLoad = (event) => {
      if (event.target?.contains(this)) {
        this.productsData = this.loadProductsData();
        this.initComparisonDrawers();
        this.initCriteriaFilter();
        this.capturePreviewBlockProducts();
        this.hasUserSelection = false;
        this.setActiveColumnCount(this.getInitialColumnCount());
        this.updatePreviewMode();
        this.updateEmptyStateUI();
        this.updateBundleButton();
        this.updateColumnControls();
        requestAnimationFrame(() => this.syncRows());
      }
    };

    onRelatedSectionLoad = (event) => {
      if (!event.target) return;

      const hasSparsetBuilder = event.target.querySelector?.('bk-media-sparset-builder')
        || event.target.matches?.('bk-media-sparset-builder')
        || event.target.querySelector?.('.shopify-section--bk-media-sparset-builder');

      if (hasSparsetBuilder) {
        this.updateBundleButton();
      }
    };

    getSelectedComparisonProducts() {
      const byBlock = new Map();
      const count = this.hasUserSelection
        ? this.getActiveColumnCount()
        : Math.max(this.getEffectiveDesktopColumnCount(), this.getEffectiveMobileColumnCount());
      const columns = this.getOrderedColumns().slice(0, count);

      columns.forEach((column) => {
        const blockId = column.dataset.blockId;
        if (!blockId || byBlock.has(blockId)) return;

        const productId = column.dataset.productId;
        const data = this.productsData[String(productId)] || this.productsData[productId];
        if (data?.variantId) {
          byBlock.set(blockId, data);
        }
      });

      return [...byBlock.values()];
    }

    findSparsetBuilderElement(sectionId) {
      const normalizedId = (sectionId || '').trim();

      if (normalizedId) {
        const section = document.getElementById(normalizedId);
        const builderInSection = section?.querySelector('bk-media-sparset-builder');
        if (builderInSection) return builderInSection;
      }

      return document.querySelector('bk-media-sparset-builder');
    }

    findSparsetBuilder() {
      return this.findSparsetBuilderElement(this.dataset.sparsetBuilderSectionId);
    }

    loadBundleDiscountTiers() {
      const script = this.querySelector('[data-comparison-bundle-discount-tiers]');

      if (!script) {
        return [
          { quantity: 2, discount: 10 },
          { quantity: 3, discount: 15 },
          { quantity: 4, discount: 20 },
          { quantity: 6, discount: 30 },
          { quantity: 8, discount: 40 }
        ];
      }

      try {
        const tiers = JSON.parse(script.textContent);
        return Array.isArray(tiers) ? tiers : [];
      } catch (error) {
        console.error('Failed to parse bundle discount tiers:', error);
        return [];
      }
    }

    getBundleDiscountPercent(count) {
      const tiers = this.loadBundleDiscountTiers()
        .slice()
        .sort((a, b) => a.quantity - b.quantity);

      let discount = 0;

      tiers.forEach((tier) => {
        if (count >= tier.quantity) {
          discount = tier.discount;
        }
      });

      return discount;
    }

    getBundleButtonText(count) {
      const template = this.dataset.bundleButtonText || 'Im Wunschset kaufen und [[discount]] % sparen';
      const discount = this.getBundleDiscountPercent(Math.max(count, this.getMinSelectable()));

      return template.replace(/\[\[discount\]\]/g, String(discount));
    }

    formatBundleMoney(cents) {
      if (typeof window.formatMoney === 'function') {
        return window.formatMoney(cents);
      }

      const amount = (cents / 100).toFixed(2).replace('.', ',');
      return `€${amount}`;
    }

    getBundleReferenceUnitPrice(priceCents, compareAtPriceCents) {
      const price = parseInt(priceCents, 10) || 0;
      const compareAt = parseInt(compareAtPriceCents, 10) || 0;
      const showVariantCompareAt = this.dataset.showVariantCompareAt === 'true';

      if (showVariantCompareAt && compareAt > price) {
        return compareAt;
      }

      return price;
    }

    getBundleTotals(products) {
      const count = products.length;
      const goalPercent = this.getBundleDiscountPercent(count);
      let priceSubtotal = 0;
      let compareSubtotal = 0;

      products.forEach((product) => {
        const price = parseInt(product.priceCents, 10) || 0;
        const compareAt = parseInt(product.compareAtPriceCents, 10) || 0;

        priceSubtotal += price;
        compareSubtotal += this.getBundleReferenceUnitPrice(price, compareAt);
      });

      const discountAmount = goalPercent > 0 ? Math.floor((priceSubtotal * Math.round(goalPercent * 100)) / 10000) : 0;
      const discountedTotal = priceSubtotal - discountAmount;
      const originalTotal = priceSubtotal;
      const showVariantCompareAt = this.dataset.showVariantCompareAt === 'true';
      const savings = (showVariantCompareAt && compareSubtotal > priceSubtotal)
        ? compareSubtotal - discountedTotal
        : priceSubtotal - discountedTotal;

      return {
        priceSubtotal,
        compareSubtotal,
        originalTotal,
        discountedTotal,
        savings,
        goalPercent
      };
    }

    getBundleBuilderPageUrl() {
      let configuredUrl = (this.dataset.bundleBuilderPageUrl || '/pages/bundle-builder').trim();
      if (!configuredUrl) return '/pages/bundle-builder';

      if (configuredUrl.includes('shopify://pages/')) {
        const handle = configuredUrl.split('shopify://pages/')[1]?.split('?')[0]?.split('/')[0];
        return handle ? `/pages/${handle}` : '/pages/bundle-builder';
      }

      try {
        const parsed = new URL(configuredUrl, window.location.origin);
        return `${parsed.pathname}${parsed.search}`;
      } catch (error) {
        return configuredUrl.startsWith('/') ? configuredUrl : `/${configuredUrl}`;
      }
    }

    isBundleBuilderOnCurrentPage() {
      const targetPath = this.getBundleBuilderPageUrl();
      return window.location.pathname === targetPath;
    }

    updateBundleButton() {
      if (!this.bundleButton) return;

      const products = this.getSelectedComparisonProducts();
      const availableProducts = products.filter((product) => product.available && product.variantId);
      const textTarget = this.bundleButton.querySelector('[data-comparison-bundle-action-text]') || this.bundleButton;
      const isDisabled = availableProducts.length < this.getMinSelectable();
      const totals = this.getBundleTotals(availableProducts);

      textTarget.textContent = this.getBundleButtonText(availableProducts.length);

      if (this.bundleSavingsRow && this.bundleSavingsAmount) {
        const showSavings = availableProducts.length > 0 && totals.savings > 0;
        this.bundleSavingsRow.hidden = !showSavings;

        if (showSavings) {
          this.bundleSavingsAmount.textContent = `-${this.formatBundleMoney(totals.savings)}`;
        }
      }

      if (this.bundlePricesEl && this.bundleSalePriceEl && this.bundleComparePriceEl) {
        const showPrices = availableProducts.length > 0;
        this.bundlePricesEl.hidden = !showPrices;

        if (showPrices) {
          this.bundleSalePriceEl.textContent = this.formatBundleMoney(totals.discountedTotal);

          if (totals.goalPercent > 0 && totals.discountedTotal < totals.originalTotal) {
            this.bundleComparePriceEl.textContent = this.formatBundleMoney(totals.originalTotal);
            this.bundleComparePriceEl.hidden = false;
          } else {
            this.bundleComparePriceEl.textContent = '';
            this.bundleComparePriceEl.hidden = true;
          }
        }
      }

      this.bundleButton.disabled = isDisabled;
      this.bundleButton.toggleAttribute('disabled', isDisabled);
      this.bundleButton.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
    }

    onBundleClick(event) {
      event.preventDefault();

      const variantIds = this.getSelectedComparisonProducts()
        .filter((product) => product.available && product.variantId)
        .map((product) => product.variantId);

      if (variantIds.length < this.getMinSelectable()) return;

      const builder = this.findSparsetBuilder();

      if (builder && typeof builder.bkMediaSetVariants === 'function' && this.isBundleBuilderOnCurrentPage()) {
        builder.bkMediaSetVariants(variantIds, { replace: true, scroll: true });
        return;
      }

      try {
        sessionStorage.setItem(BK_MEDIA_COMPARISON_BUNDLE_STORAGE_KEY, JSON.stringify(variantIds));

        const sparsetSectionId = (this.dataset.sparsetBuilderSectionId || '').trim();
        if (sparsetSectionId) {
          sessionStorage.setItem(BK_MEDIA_COMPARISON_SPARSET_SECTION_KEY, sparsetSectionId);
        } else {
          sessionStorage.removeItem(BK_MEDIA_COMPARISON_SPARSET_SECTION_KEY);
        }
      } catch (error) {
        console.error('Failed to store comparison bundle variants:', error);
      }

      const targetPath = this.getBundleBuilderPageUrl();
      const targetUrl = new URL(targetPath, window.location.origin);
      targetUrl.searchParams.set('variants', variantIds.join(','));
      window.location.assign(`${targetUrl.pathname}${targetUrl.search}`);
    }

    getComparisonDrawers() {
      return Array.from(document.querySelectorAll(`[data-comparison-drawer][data-comparison-section-id="${this.dataset.sectionId}"]`));
    }

    initComparisonDrawers() {
      this.getComparisonDrawers().forEach((drawer) => {
        drawer.removeEventListener('dialog:after-hide', this.onDrawerHide);
        drawer.removeEventListener('dialog:after-show', this.onDrawerShow);
        drawer.addEventListener('dialog:after-hide', this.onDrawerHide);
        drawer.addEventListener('dialog:after-show', this.onDrawerShow);
      });
    }

    onDrawerShow(event) {
      const drawer = event.currentTarget;
      if (drawer.dataset.comparisonSectionId !== this.dataset.sectionId) return;

      this.initDrawerSelection(drawer);
      this.updateDrawerTriggerState(drawer, true);
      this.updateEmptyStateUI();
    }

    onDrawerHide(event) {
      const drawer = event.currentTarget;
      if (drawer.dataset.comparisonSectionId !== this.dataset.sectionId) return;

      this.drawerSelectedIds = [];
      this.resetDrawerSearch(drawer);
      this.updateDrawerTriggerState(drawer, false);
      this.updateDrawerFooter(drawer);
      this.updateEmptyStateUI();
    }

    updateDrawerTriggerState(drawer, isOpen) {
      if (!drawer?.id) return;

      this.querySelectorAll(`[data-comparison-drawer-trigger][data-drawer-id="${drawer.id}"]`).forEach((trigger) => {
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    closeAllDrawers(exceptDrawer) {
      this.getComparisonDrawers().forEach((drawer) => {
        if (drawer !== exceptDrawer && drawer.open && typeof drawer.hide === 'function') {
          drawer.hide();
        }
      });
    }

    onDrawerTriggerClick(event) {
      const trigger = event.target.closest('[data-comparison-drawer-trigger], [data-comparison-add-trigger]');
      if (!trigger || !this.contains(trigger)) return;

      const drawer = document.getElementById(trigger.dataset.drawerId);
      if (!drawer || drawer.dataset.comparisonSectionId !== this.dataset.sectionId) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (drawer.open) {
        drawer.hide();
        return;
      }

      this.closeAllDrawers(drawer);
      drawer.show();
    }

    shouldShowBundleAtcPrompt() {
      if (this.dataset.showBundleButton !== 'true') return false;

      const bundleBar = this.querySelector('[data-comparison-bundle-bar]');
      if (!bundleBar || this.bundlePlacement?.hidden) return false;
      if (!this.bundleButton || this.bundleButton.disabled) return false;

      const availableProducts = this.getSelectedComparisonProducts()
        .filter((product) => product.available && product.variantId);

      return availableProducts.length >= this.getMinSelectable();
    }

    onAtcSubmit(event) {
      const form = event.target.closest('form[is="product-form"]');
      if (!form || !this.contains(form)) return;

      if (form.dataset.comparisonAtcBypass === 'true') {
        delete form.dataset.comparisonAtcBypass;
        return;
      }

      if (!this.shouldShowBundleAtcPrompt()) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      this.pendingAtcForm = form;
      this.showBundlePrompt();
    }

    onBundlePromptClick(event) {
      if (!this.bundlePrompt || this.bundlePrompt.hidden) return;

      if (event.target.closest('[data-comparison-bundle-prompt-close]')) {
        event.preventDefault();
        this.dismissBundlePrompt();
        return;
      }

      if (event.target === this.bundlePrompt) {
        this.dismissBundlePrompt();
        return;
      }

      if (!this.bundlePrompt.contains(event.target)) return;

      if (event.target.closest('[data-comparison-bundle-prompt-yes]')) {
        event.preventDefault();
        this.dismissBundlePrompt();
        this.scrollToBundleButton();
        return;
      }

      if (event.target.closest('[data-comparison-bundle-prompt-no]')) {
        event.preventDefault();
        this.submitPendingAtcForm();
      }
    }

    onBundlePromptKeydown(event) {
      if (!this.bundlePrompt || this.bundlePrompt.hidden) return;
      if (event.key !== 'Escape') return;

      event.preventDefault();
      this.dismissBundlePrompt();
    }

    showBundlePrompt() {
      if (!this.bundlePrompt) return;
      this.bundlePrompt.hidden = false;
    }

    dismissBundlePrompt() {
      this.hideBundlePrompt();
      this.pendingAtcForm = null;
    }

    hideBundlePrompt() {
      if (!this.bundlePrompt) return;
      this.bundlePrompt.hidden = true;
    }

    submitPendingAtcForm() {
      const form = this.pendingAtcForm;
      this.dismissBundlePrompt();

      if (!form) return;

      form.dataset.comparisonAtcBypass = 'true';

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }

    scrollToBundleButton() {
      const target = this.bundleBar || this.bundleButton;
      if (!target) return;

      const stickyOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;
      const top = target.getBoundingClientRect().top + window.scrollY - stickyOffset - 16;

      window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth'
      });
    }

    onColumnControlClick(event) {
      const removeButton = event.target.closest('[data-comparison-column-remove]');
      if (!removeButton || !this.contains(removeButton)) return;

      event.preventDefault();
      event.stopPropagation();
      this.removeComparisonColumn(removeButton.dataset.blockId);
    }

    getCurrentComparisonProductIds() {
      const count = this.hasUserSelection
        ? this.getActiveColumnCount()
        : Math.max(this.getEffectiveDesktopColumnCount(), this.getEffectiveMobileColumnCount());

      return this.getOrderedColumns()
        .slice(0, count)
        .map((column) => column.dataset.productId)
        .filter(Boolean)
        .map(String);
    }

    removeComparisonColumn(blockId) {
      if (!this.hasSelectors() || !blockId) return;

      const columns = this.getOrderedColumns();
      const desktopCount = this.getEffectiveDesktopColumnCount();
      const mobileCount = this.getEffectiveMobileColumnCount();
      const removeIndex = columns.findIndex((column) => column.dataset.blockId === blockId);

      if (removeIndex < 0) return;

      const isDesktopRemove = removeIndex < desktopCount;
      const isMobileRemove = removeIndex < mobileCount;

      if (!isDesktopRemove && !isMobileRemove) return;

      const currentCount = this.hasUserSelection
        ? this.getActiveColumnCount()
        : Math.max(isDesktopRemove ? desktopCount : 0, isMobileRemove ? mobileCount : 0);

      if (currentCount <= this.getMinSelectable()) return;

      const assignments = columns.slice(0, currentCount).map((column) => column.dataset.productId || null);
      assignments.splice(removeIndex, 1);

      this.hasUserSelection = true;

      assignments.forEach((productId, index) => {
        if (productId) {
          this.switchProduct(columns[index], productId, { showConfirmation: false });
        }
      });

      this.setActiveColumnCount(assignments.length);
      this.drawerSelectedIds = assignments.filter(Boolean).map(String);
      this.showSwapConfirmation('Produkt entfernt');
      this.updateBundleButton();

      this.getComparisonDrawers().forEach((drawer) => {
        this.updateDrawerOptionStates(drawer);
        this.updateDrawerFooter(drawer);
      });
    }

    updateColumnControls() {
      if (!this.hasSelectors()) return;

      const desktopCount = this.getEffectiveDesktopColumnCount();
      const mobileCount = this.getEffectiveMobileColumnCount();
      const maxVisibleCount = Math.max(desktopCount, mobileCount, this.getActiveColumnCount());
      const canAdd = maxVisibleCount < this.getMaxSelectable();

      this.querySelectorAll('[data-comparison-add-wrap]').forEach((wrap) => {
        const isDesktop = wrap.classList.contains('bk-media-product-comparison__add-slot-wrap--desktop');

        if (isDesktop && !this.hasUserSelection) {
          wrap.hidden = true;
          return;
        }

        wrap.hidden = !canAdd;
      });

      this.querySelectorAll('[data-comparison-column-remove]').forEach((button) => {
        const blockId = button.dataset.blockId;
        const columnIndex = this.getOrderedColumns().findIndex((column) => column.dataset.blockId === blockId);

        if (columnIndex < 0) {
          button.hidden = true;
          return;
        }

        const isDesktopButton = button.classList.contains('bk-media-product-comparison__column-remove--desktop');
        const isMobileButton = button.classList.contains('bk-media-product-comparison__column-remove--mobile');
        let canRemove = false;

        if (isDesktopButton && columnIndex < desktopCount) {
          canRemove = desktopCount > this.getMinSelectable();
        } else if (isMobileButton && columnIndex < mobileCount) {
          canRemove = mobileCount > 1;
        }

        button.hidden = !canRemove;
      });
    }

    onDrawerSearch(event) {
      const input = event.target.closest('[data-comparison-drawer-search]');
      if (!input) return;

      const drawer = input.closest('[data-comparison-drawer]');
      if (!drawer || drawer.dataset.comparisonSectionId !== this.dataset.sectionId) return;

      if (event.type === 'reset') {
        requestAnimationFrame(() => this.filterDrawerOptions(drawer, ''));
        return;
      }

      this.filterDrawerOptions(drawer, input.value);
    }

    filterDrawerOptions(drawer, query) {
      if (!drawer) return;

      const normalized = query.trim().toLowerCase();
      let visibleCount = 0;

      drawer.querySelectorAll('.bk-media-product-comparison__drawer-option').forEach((option) => {
        const title = (option.dataset.searchTitle || option.textContent || '').toLowerCase();
        const isVisible = normalized === '' || title.includes(normalized);
        option.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      const emptyState = drawer.querySelector('.bk-media-product-comparison__drawer-empty');
      if (emptyState) emptyState.hidden = visibleCount > 0;

      this.sortDrawerOptions(drawer);
    }

    sortDrawerOptions(drawer) {
      if (!drawer) return;

      const results = drawer.querySelector('.bk-media-product-comparison__drawer-results');
      if (!results) return;

      const options = [...results.querySelectorAll('.bk-media-product-comparison__drawer-option')];
      const selected = options.filter((option) => option.classList.contains('is-selected'));
      const others = options.filter((option) => !option.classList.contains('is-selected'));

      [...selected, ...others].forEach((option) => {
        results.appendChild(option);
      });
    }

    getOrderedColumns() {
      return [...this.querySelectorAll('.bk-media-product-comparison__column[data-block-id][data-product-id]')];
    }

    getActiveColumnCount() {
      return this.activeColumnCount ?? this.getOrderedColumns().length;
    }

    getMaxSelectable() {
      const max = parseInt(this.dataset.comparisonMaxProducts, 10);
      return Number.isFinite(max) && max > 0 ? max : 20;
    }

    getMinSelectable() {
      const min = parseInt(this.dataset.comparisonMinProducts, 10);
      return Number.isFinite(min) && min > 0 ? min : 2;
    }

    getVisibleColumnCount() {
      const visible = parseInt(this.dataset.comparisonVisibleColumns, 10);
      return Number.isFinite(visible) && visible > 0 ? visible : 5;
    }

    hasSelectors() {
      return this.dataset.comparisonHasSelectors === 'true';
    }

    getPreviewDesktopColumnCount() {
      const preview = parseInt(this.dataset.comparisonPreviewColumnsDesktop, 10);

      if (Number.isFinite(preview) && preview > 0) {
        return Math.min(preview, this.getOrderedColumns().length, this.getMaxSelectable());
      }

      return 0;
    }

    getPreviewMobileColumnCount() {
      const preview = parseInt(this.dataset.comparisonPreviewColumnsMobile, 10);

      if (Number.isFinite(preview) && preview > 0) {
        return Math.min(preview, this.getOrderedColumns().length, this.getMaxSelectable());
      }

      return 0;
    }

    getEffectiveDesktopColumnCount() {
      if (!this.hasSelectors() || this.hasUserSelection) {
        return this.getActiveColumnCount();
      }

      return this.getPreviewDesktopColumnCount();
    }

    getEffectiveMobileColumnCount() {
      if (!this.hasSelectors() || this.hasUserSelection) {
        return this.getActiveColumnCount();
      }

      return this.getPreviewMobileColumnCount();
    }

    getInitialColumnCount() {
      if (this.hasSelectors()) {
        return 0;
      }

      const initial = parseInt(this.dataset.comparisonInitialColumns, 10);
      if (Number.isFinite(initial) && initial > 0) {
        return Math.min(initial, this.getOrderedColumns().length, this.getMaxSelectable());
      }

      return Math.min(this.getOrderedColumns().length, this.getMaxSelectable());
    }

    capturePreviewBlockProducts() {
      this.previewBlockProducts = new Map();

      this.getOrderedColumns().forEach((column) => {
        const blockId = column.dataset.blockId;
        const productId = column.dataset.productId;

        if (blockId && productId) {
          this.previewBlockProducts.set(blockId, productId);
        }
      });
    }

    updatePreviewMode() {
      const isPreview = this.hasSelectors() && !this.hasUserSelection;
      this.toggleAttribute('data-comparison-preview', isPreview);
      this.updateEmptyStateUI();
    }

    updateEmptyStateUI() {
      const emptyState = this.querySelector('[data-comparison-empty-state]');
      const selectorLabel = this.querySelector('[data-comparison-selector-label]');
      const hint = this.querySelector('[data-comparison-empty-hint]');
      const isPreview = this.hasSelectors() && !this.hasUserSelection;
      const selectedCount = this.drawerSelectedIds.length;
      const minSelectable = this.getMinSelectable();

      if (emptyState) {
        emptyState.hidden = !isPreview;
      }

      if (selectorLabel) {
        if (this.hasUserSelection) {
          selectorLabel.textContent = this.selectorDefaultText;
        } else if (selectedCount >= minSelectable) {
          selectorLabel.textContent = `${selectedCount} Produkte ausgewählt`;
        } else if (selectedCount > 0) {
          selectorLabel.textContent = `${selectedCount} von ${minSelectable} Produkten`;
        } else {
          selectorLabel.textContent = this.selectorDefaultText;
        }
      }

      if (hint && isPreview) {
        if (selectedCount >= minSelectable) {
          hint.textContent = `${selectedCount} Produkte bereit – tippe auf „Jetzt vergleichen“ im Drawer.`;
        } else if (selectedCount > 0) {
          hint.textContent = `Noch ${minSelectable - selectedCount} Produkt${minSelectable - selectedCount === 1 ? '' : 'e'} wählen, um zu vergleichen.`;
        } else {
          hint.textContent = this.emptyStateHintDefault;
        }
      }

      this.querySelectorAll('[data-comparison-step]').forEach((step) => {
        const stepNumber = parseInt(step.dataset.comparisonStep, 10);
        let isActive = false;

        if (stepNumber === 1) {
          isActive = isPreview && selectedCount < minSelectable;
        } else if (stepNumber === 2) {
          isActive = isPreview && selectedCount >= minSelectable;
        } else if (stepNumber === 3) {
          isActive = !isPreview;
        }

        step.classList.toggle('bk-media-product-comparison__step--active', isActive);
      });
    }

    getSectionElement() {
      return document.getElementById(`shopify-section-${this.dataset.sectionId}`);
    }

    setDesktopSlotVisibility(blockId, visible) {
      const element = this.querySelector(`.bk-media-product-comparison__column[data-block-id="${blockId}"]`);
      if (!element) return;

      element.hidden = !visible;
    }

    setMobileSlotVisibility(blockId, visible) {
      const element = this.querySelector(`.bk-media-product-comparison__mobile-product[data-block-id="${blockId}"]`);
      if (!element) return;

      element.hidden = !visible;
    }

    initProductsScroll() {
      const productsScroll = this.querySelector('[data-comparison-products-scroll]');
      if (!productsScroll) return;

      if (!this._productsScrollInit) {
        this._productsScrollInit = true;

        const scrollByColumn = (direction) => {
          const sample = productsScroll.querySelector('.bk-media-product-comparison__column:not([hidden]), .bk-media-product-comparison__add-slot-wrap--desktop:not([hidden])');
          if (!sample) return;

          const gapValue = getComputedStyle(this).getPropertyValue('--bk-comparison-column-gap').trim();
          const gap = parseFloat(gapValue) || 16;
          const amount = (sample.offsetWidth + gap) * direction;
          const delta = document.dir === 'rtl' ? -amount : amount;

          productsScroll.scrollBy({
            left: delta,
            behavior: window.matchMedia('(prefers-reduced-motion: no-preference)').matches ? 'smooth' : 'auto'
          });
        };

        productsScroll.addEventListener('control:prev', () => scrollByColumn(-1));
        productsScroll.addEventListener('control:next', () => scrollByColumn(1));

        this._productsScrollEdgeHandler = () => this.updateProductsScrollEdges(productsScroll);
        productsScroll.addEventListener('scroll', this._productsScrollEdgeHandler, { passive: true });

        this._productsScrollResizeObserver = new ResizeObserver(() => {
          requestAnimationFrame(() => this.updateProductsScrollEdges(productsScroll));
        });
        this._productsScrollResizeObserver.observe(productsScroll);
      }

      requestAnimationFrame(() => this.updateProductsScrollEdges(productsScroll));
    }

    updateProductsScrollEdges(productsScroll) {
      const threshold = 125;
      const scrollLeft = Math.round(Math.abs(productsScroll.scrollLeft));
      const scrollMinusSize = Math.round(productsScroll.scrollWidth - productsScroll.clientWidth);

      if (scrollLeft <= threshold) {
        productsScroll.dispatchEvent(new CustomEvent('scroll:edge-nearing', { bubbles: true, detail: { position: 'start' } }));
      } else {
        productsScroll.dispatchEvent(new CustomEvent('scroll:edge-leaving', { bubbles: true, detail: { position: 'start' } }));
      }

      if (scrollMinusSize <= 0 || scrollLeft >= scrollMinusSize - threshold) {
        productsScroll.dispatchEvent(new CustomEvent('scroll:edge-nearing', { bubbles: true, detail: { position: 'end' } }));
      } else {
        productsScroll.dispatchEvent(new CustomEvent('scroll:edge-leaving', { bubbles: true, detail: { position: 'end' } }));
      }
    }

    applyColumnVisibility() {
      const columns = this.getOrderedColumns();
      const desktopCount = this.getEffectiveDesktopColumnCount();
      const mobileCount = this.getEffectiveMobileColumnCount();

      columns.forEach((column, index) => {
        const blockId = column.dataset.blockId;
        if (!blockId) return;

        this.setDesktopSlotVisibility(blockId, index < desktopCount);
        this.setMobileSlotVisibility(blockId, index < mobileCount);
      });

      const addWrap = this.querySelector('[data-comparison-add-wrap].bk-media-product-comparison__add-slot-wrap--desktop');
      const addVisible = addWrap && !addWrap.hidden;
      const scrollSlotCount = desktopCount + (addVisible ? 1 : 0);
      const visibleColumnCount = this.getVisibleColumnCount();
      const isScrollable = scrollSlotCount > visibleColumnCount;
      const productsScroll = this.querySelector('[data-comparison-products-scroll]');
      const scrollProgress = this.querySelector('.bk-media-product-comparison__products-scrollable .scrollbar__progress');

      this.style.setProperty('--bk-comparison-scroll-column-count', String(Math.max(scrollSlotCount, 1)));
      this.toggleAttribute('data-comparison-scrollable', isScrollable);

      if (productsScroll) {
        productsScroll.classList.toggle('is-scrollable', isScrollable);
      }

      if (scrollProgress && scrollSlotCount > 0) {
        const defaultProgress = Math.min(1, visibleColumnCount / scrollSlotCount);
        scrollProgress.style.setProperty('--scroll-progress', String(defaultProgress));
      }

      requestAnimationFrame(() => {
        if (productsScroll) {
          this.updateProductsScrollEdges(productsScroll);
        }
      });
    }

    setActiveColumnCount(count) {
      const maxColumns = Math.min(this.getOrderedColumns().length, this.getMaxSelectable());
      const nextCount = Math.max(0, Math.min(count, maxColumns));

      this.activeColumnCount = nextCount;

      this.applyColumnVisibility();

      this.updateComparisonLayoutVisibility();
      requestAnimationFrame(() => this.syncRows());
      this.updateBundleButton();
      this.updatePreviewMode();
      this.updateColumnControls();
    }

    initCriteriaFilter() {
      const filter = this.querySelector('[data-comparison-criteria-filter]');
      if (!filter) return;

      filter.querySelectorAll('[data-comparison-criterion-toggle]').forEach((input) => {
        input.removeEventListener('change', this.onCriteriaToggle);
        input.addEventListener('change', this.onCriteriaToggle);
      });

      this.applyCriteriaVisibility();
    }

    onCriteriaToggle() {
      this.applyCriteriaVisibility();
    }

    applyCriteriaVisibility() {
      const filter = this.querySelector('[data-comparison-criteria-filter]');
      if (!filter) return;

      filter.querySelectorAll('[data-comparison-criterion-toggle]').forEach((toggle) => {
        const key = toggle.dataset.comparisonCriterionToggle;
        if (!key || key === 'header') return;

        const visible = toggle.checked;
        this.querySelectorAll(`[data-row="${key}"]`).forEach((row) => {
          row.hidden = !visible;
        });
      });

      requestAnimationFrame(() => this.syncRows());
    }

    isVisibleCriterionRow(row) {
      return row && !row.hidden;
    }

    updateComparisonLayoutVisibility() {
      const count = this.getActiveColumnCount();
      const desktop = this.querySelector('.bk-media-product-comparison__desktop');
      const mobile = this.querySelector('.bk-media-product-comparison__mobile');
      const hasSelectors = this.hasSelectors();
      const showDesktop = hasSelectors ? (this.hasUserSelection && count > 0) : count > 0;
      const showMobile = hasSelectors ? true : count > 0;
      const showBundle = this.hasUserSelection && count > 0;

      if (desktop) {
        desktop.hidden = !showDesktop;
      }

      if (mobile) {
        mobile.hidden = !showMobile;
      }

      if (this.bundlePlacement) {
        this.bundlePlacement.hidden = !showBundle;
      }
    }

    initDrawerSelection(drawer) {
      this.drawerSelectedIds = this.getCurrentComparisonProductIds();
      this.updateDrawerOptionStates(drawer);
      this.updateDrawerFooter(drawer);
      this.updateEmptyStateUI();
    }

    updateDrawerOptionStates(drawer) {
      if (!drawer) return;

      const maxSelectable = this.getMaxSelectable();
      const atMax = this.drawerSelectedIds.length >= maxSelectable;

      drawer.querySelectorAll('.bk-media-product-comparison__drawer-option').forEach((button) => {
        const productId = button.dataset.productId;
        const isSelected = this.drawerSelectedIds.includes(productId);

        button.classList.toggle('is-selected', isSelected);
        button.classList.toggle('is-disabled', atMax && !isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      this.sortDrawerOptions(drawer);
    }

    toggleDrawerProduct(drawer, productId) {
      if (!drawer || !productId) return;

      const normalizedId = String(productId);
      const currentIndex = this.drawerSelectedIds.indexOf(normalizedId);

      if (currentIndex >= 0) {
        this.drawerSelectedIds.splice(currentIndex, 1);
      } else if (this.drawerSelectedIds.length < this.getMaxSelectable()) {
        this.drawerSelectedIds.push(normalizedId);
      }

      this.updateDrawerOptionStates(drawer);
      this.updateDrawerFooter(drawer);
      this.updateEmptyStateUI();
    }

    removeDrawerProduct(drawer, productId) {
      if (!drawer || !productId) return;

      const normalizedId = String(productId);
      const currentIndex = this.drawerSelectedIds.indexOf(normalizedId);

      if (currentIndex < 0) return;

      this.drawerSelectedIds.splice(currentIndex, 1);
      this.updateDrawerOptionStates(drawer);
      this.updateDrawerFooter(drawer);
      this.updateEmptyStateUI();
    }

    getDrawerCompareButtonText(count) {
      const minSelectable = this.getMinSelectable();
      const remaining = minSelectable - count;

      if (remaining > 0) {
        if (remaining === 1) {
          return 'Noch 1 Produkt wählen';
        }

        return `Noch ${remaining} Produkte wählen`;
      }

      return `Jetzt ${count} Produkte vergleichen`;
    }

    updateDrawerFooter(drawer) {
      if (!drawer) return;

      const footer = drawer.querySelector('[data-comparison-drawer-footer]');
      const selection = drawer.querySelector('[data-comparison-drawer-selection]');
      const compareButton = drawer.querySelector('[data-comparison-drawer-compare]');

      if (!footer || !selection || !compareButton) return;

      if (this.drawerSelectedIds.length === 0) {
        footer.hidden = false;
        selection.innerHTML = '';
        compareButton.disabled = true;
        compareButton.textContent = this.getDrawerCompareButtonText(0);
        return;
      }

      footer.hidden = false;

      const selectedCount = this.drawerSelectedIds.length;
      compareButton.disabled = selectedCount < this.getMinSelectable();
      compareButton.textContent = this.getDrawerCompareButtonText(selectedCount);

      selection.innerHTML = this.drawerSelectedIds.map((productId) => {
        const data = this.productsData[String(productId)] || this.productsData[productId];
        if (!data) return '';

        const title = this.escapeHtml(data.title || '');
        const imageUrl = data.imageUrl ? this.escapeHtml(data.imageUrl) : '';
        const imageAlt = this.escapeHtml(data.imageAlt || data.title || '');

        return `
          <div class="bk-media-product-comparison__drawer-chip">
            ${imageUrl ? `<img src="${imageUrl}" alt="${imageAlt}" loading="lazy" width="48" height="48">` : ''}
            <span class="bk-media-product-comparison__drawer-chip-title text-xs">${title}</span>
            <button type="button" class="bk-media-product-comparison__drawer-chip-remove" data-comparison-drawer-remove="${productId}" aria-label="Entfernen">
              <svg role="presentation" focusable="false" width="12" height="12" viewBox="0 0 16 16"><path d="M4 4L12 12M12 4L4 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
            </button>
          </div>
        `;
      }).join('');
    }

    applyDrawerComparison(drawer) {
      if (!drawer || this.drawerSelectedIds.length < this.getMinSelectable()) return;

      const columns = this.getOrderedColumns();
      const activeCount = this.drawerSelectedIds.length;

      this.hasUserSelection = true;

      columns.forEach((column, index) => {
        const productId = this.drawerSelectedIds[index];
        if (!productId) return;

        this.switchProduct(column, productId, { showConfirmation: false });
      });

      this.setActiveColumnCount(activeCount);
      this.showSwapConfirmation('Vergleich aktualisiert');
      this.updateBundleButton();
      this.updateEmptyStateUI();

      if (drawer.open) {
        drawer.hide();
      }
    }

    onDrawerFooterClick(event) {
      const removeButton = event.target.closest('[data-comparison-drawer-remove]');
      if (removeButton) {
        const drawer = removeButton.closest('[data-comparison-drawer]');
        if (!drawer || drawer.dataset.comparisonSectionId !== this.dataset.sectionId) return;

        event.preventDefault();
        this.removeDrawerProduct(drawer, removeButton.dataset.comparisonDrawerRemove);
        return;
      }

      const compareButton = event.target.closest('[data-comparison-drawer-compare]');
      if (!compareButton) return;

      const drawer = compareButton.closest('[data-comparison-drawer]');
      if (!drawer || drawer.dataset.comparisonSectionId !== this.dataset.sectionId) return;

      event.preventDefault();
      this.applyDrawerComparison(drawer);
    }

    resetDrawerSearch(drawer) {
      if (!drawer) return;

      const input = drawer.querySelector('[data-comparison-drawer-search]');
      if (input) input.value = '';
      this.filterDrawerOptions(drawer, '');
    }

    loadProductsData() {
      const script = this.querySelector('[data-comparison-products]');

      if (!script) return {};

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        console.error('Failed to parse comparison products JSON:', error);
        return {};
      }
    }

    onSelectorClick(event) {
      const removeButton = event.target.closest('[data-comparison-drawer-option-remove]');
      if (removeButton) {
        const option = removeButton.closest('.bk-media-product-comparison__drawer-option');
        const drawer = option?.closest('[data-comparison-drawer]');
        if (!option || !drawer || drawer.dataset.comparisonSectionId !== this.dataset.sectionId) return;

        event.preventDefault();
        event.stopPropagation();
        this.removeDrawerProduct(drawer, option.dataset.productId);
        return;
      }

      const option = event.target.closest('.bk-media-product-comparison__drawer-option');
      if (!option || option.classList.contains('is-disabled')) return;

      const drawer = option.closest('[data-comparison-drawer]');
      if (!drawer || drawer.dataset.comparisonSectionId !== this.dataset.sectionId) return;

      event.preventDefault();
      event.stopPropagation();

      this.toggleDrawerProduct(drawer, option.dataset.productId);
    }

    switchProduct(triggerColumn, productId, options = {}) {
      const data = this.productsData[String(productId)] || this.productsData[productId];
      if (!data) return;

      const blockId = triggerColumn.dataset.blockId;
      const columns = this.querySelectorAll(`[data-block-id="${blockId}"][data-product-id]`);

      columns.forEach((column) => {
        column.dataset.productId = productId;

        this.updateCard(column.querySelector('[data-comparison-card]'), data);
      });

      this.updateButtons(blockId, data);

      columns.forEach((column) => {
        const image = column.querySelector('[data-comparison-card] img');
        if (image && !image.complete) {
          image.addEventListener('load', () => this.syncRows(), { once: true });
        }
      });

      requestAnimationFrame(() => this.syncRows());

      if (options.showConfirmation !== false) {
        this.showSwapConfirmation(data.title);
      }

      this.updateBundleButton();
    }

    showSwapConfirmation(productTitle) {
      if (!this.swapConfirmation) {
        this.swapConfirmation = this.querySelector('.bk-media-product-comparison__swap-confirmation');
        this.swapConfirmationText = this.querySelector('.bk-media-product-comparison__swap-confirmation-text');
      }

      if (!this.swapConfirmation || !this.swapConfirmationText) return;

      const template = this.dataset.swapConfirmationMessage || 'Produkt erfolgreich gewechselt';
      const message = template.replace(/\[\[product\]\]/g, productTitle);

      if (this.swapConfirmationTimeout) {
        clearTimeout(this.swapConfirmationTimeout);
      }

      this.swapConfirmationText.textContent = message;
      this.swapConfirmation.setAttribute('aria-hidden', 'false');
      this.swapConfirmation.classList.add('is-visible');

      this.swapConfirmationTimeout = setTimeout(() => {
        this.swapConfirmation.classList.remove('is-visible');
        this.swapConfirmation.setAttribute('aria-hidden', 'true');
      }, 3000);
    }

    onGalleryTriggerClick(event) {
      const trigger = event.target.closest('[data-comparison-gallery-trigger]');
      if (!trigger || trigger.disabled || trigger.hidden || !this.contains(trigger)) return;

      event.preventDefault();
      event.stopPropagation();

      const column = trigger.closest('[data-product-id]');
      const productId = column?.dataset.productId || trigger.dataset.productId;
      if (!productId) return;

      const data = this.productsData[String(productId)] || this.productsData[productId];
      if (!data?.gallery?.length) return;

      this.openProductGallery(data, trigger.querySelector('img'));
    }

    getPhotoSwipeCloseSvg() {
      return `<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
        <path d="M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28Z" fill="#fff"/>
        <path d="M55.5 28C55.5 12.812 43.188.5 28 .5S.5 12.812.5 28 12.812 55.5 28 55.5 55.5 43.188 55.5 28Z" stroke="#252627" stroke-opacity=".12"/>
        <path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/>
      </svg>`;
    }

    async initPhotoSwipe() {
      if (this._photoSwipeLightbox) {
        return this._photoSwipeLightbox;
      }

      const vendorUrl = this.dataset.vendorUrl;
      const photoswipeUrl = this.dataset.photoswipeUrl;

      if (!vendorUrl || !photoswipeUrl) {
        return null;
      }

      try {
        const { PhotoSwipeLightbox } = await import(vendorUrl);
        const maxZoomLevel = parseFloat(this.dataset.comparisonMaxZoom) || 3;
        const strings = window.themeVariables?.strings || {};

        const lightbox = new PhotoSwipeLightbox({
          pswpModule: () => import(photoswipeUrl),
          bgOpacity: 1,
          maxZoomLevel,
          closeTitle: strings.closeGallery || 'Close',
          zoomTitle: strings.zoomGallery || 'Zoom',
          errorMsg: strings.errorGallery || 'The image could not be loaded.',
          paddingFn: (viewportSize) => {
            const desktop = viewportSize.x >= 700;
            return {
              top: 0,
              bottom: desktop ? 96 : 72,
              left: 0,
              right: 0
            };
          },
          arrowPrev: false,
          arrowNext: false,
          counter: false,
          zoom: false,
          closeSVG: this.getPhotoSwipeCloseSvg()
        });

        lightbox.addFilter('thumbEl', (thumbEl, data) => data.thumbnailElement);
        lightbox.on('uiRegister', () => {
          lightbox.pswp.ui.registerElement({
            name: 'bottom-bar',
            order: 5,
            appendTo: 'wrapper',
            html: `
              <div class="pagination">
                <button class="pagination__item group" rel="prev">
                  <span class="animated-arrow animated-arrow--reverse"></span>
                </button>
                <span class="pagination__current text-sm">
                  <span class="pagination__current-page">1</span> / <span class="pagination__page-count"></span>
                </span>
                <button class="pagination__item group" rel="next">
                  <span class="animated-arrow"></span>
                </button>
              </div>
            `,
            onInit: (el, pswp) => {
              el.querySelector('.pagination__page-count').innerText = pswp.getNumItems();
              el.querySelector('[rel="prev"]')?.addEventListener('click', () => pswp.prev());
              el.querySelector('[rel="next"]')?.addEventListener('click', () => pswp.next());
              pswp.on('change', () => {
                el.querySelector('.pagination__current-page').innerText = pswp.currIndex + 1;
              });
            }
          });
        });

        lightbox.init();
        this._photoSwipeLightbox = lightbox;
        return lightbox;
      } catch (error) {
        console.error('Failed to initialize comparison gallery lightbox:', error);
        return null;
      }
    }

    async openProductGallery(data, thumbnailElement) {
      const lightbox = await this.initPhotoSwipe();
      if (!lightbox) return;

      let startIndex = 0;

      if (data.imageMediaId) {
        const matchedIndex = data.gallery.findIndex((item) => String(item.id) === String(data.imageMediaId));
        if (matchedIndex >= 0) {
          startIndex = matchedIndex;
        }
      }

      const dataSource = data.gallery.map((item, index) => ({
        thumbnailElement: index === startIndex ? thumbnailElement : null,
        src: item.src,
        msrc: item.src,
        width: parseInt(item.width, 10) || 1200,
        height: parseInt(item.height, 10) || 1200,
        alt: item.alt || data.title || '',
        thumbCropped: true
      }));

      lightbox.loadAndOpen(startIndex, dataSource);
    }

    getGalleryZoomMarkup() {
      return `<span class="bk-media-product-comparison__image-zoom" aria-hidden="true">
        <svg role="presentation" fill="none" stroke-width="2" focusable="false" width="12" height="12" viewBox="0 0 15 15">
          <circle cx="7.067" cy="7.067" r="6.067" stroke="currentColor"></circle>
          <path d="M11.4 11.4 14 14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M7 4v6M4 7h6" stroke="currentColor"></path>
        </svg>
      </span>`;
    }

    ensureGalleryZoom(imageWrap, visible) {
      if (!imageWrap) return;

      let zoom = imageWrap.querySelector('.bk-media-product-comparison__image-zoom');

      if (!zoom && visible) {
        imageWrap.insertAdjacentHTML('beforeend', this.getGalleryZoomMarkup());
        zoom = imageWrap.querySelector('.bk-media-product-comparison__image-zoom');
      }

      if (zoom) {
        zoom.hidden = !visible;
      }
    }

    updateColumnImages(column, data) {
      if (!column) return;

      const hasGallery = Array.isArray(data.gallery) && data.gallery.length > 0;
      const imageContainers = [
        column.querySelector('.bk-media-product-comparison__desktop-column-header-image'),
        column.querySelector('.bk-media-product-comparison__mobile-sticky-lead-image')
      ].filter(Boolean);

      imageContainers.forEach((container) => {
        const trigger = this.ensureGalleryTrigger(container, data.id);

        trigger.dataset.productId = String(data.id);
        trigger.disabled = !hasGallery;
        trigger.setAttribute('aria-disabled', hasGallery ? 'false' : 'true');

        const imageWrap = trigger.querySelector('.bk-media-product-comparison__image');

        if (data.imageUrl && imageWrap) {
          trigger.hidden = false;
          const alt = this.escapeHtml(data.imageAlt || data.title);
          imageWrap.innerHTML = `<img src="${this.escapeHtml(data.imageUrl)}" alt="${alt}" loading="lazy" width="400" height="400">`;
          this.ensureGalleryZoom(imageWrap, hasGallery);
          return;
        }

        if (!hasGallery) {
          trigger.hidden = true;
          if (imageWrap) imageWrap.innerHTML = '';
          return;
        }

        this.ensureGalleryZoom(imageWrap, hasGallery);
      });
    }

    ensureGalleryTrigger(container, productId) {
      let trigger = container.querySelector('[data-comparison-gallery-trigger]');

      if (!trigger) {
        trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'bk-media-product-comparison__image-trigger';
        trigger.setAttribute('data-comparison-gallery-trigger', '');

        const imageWrap = document.createElement('span');
        imageWrap.className = 'bk-media-product-comparison__image';
        trigger.appendChild(imageWrap);
        container.appendChild(trigger);
      }

      if (productId) {
        trigger.dataset.productId = String(productId);
      }

      return trigger;
    }

    updateCard(card, data) {
      if (!card) return;

      const title = card.querySelector('.bk-media-product-comparison__product-title');
      if (title) title.textContent = data.title;

      const column = card.closest('[data-product-id]');
      this.updateColumnImages(column, data);

      if (this.dataset.showPrice === 'true') {
        this.updateRow(card, 'price', [data.price, data.preispro]);
      }

      if (this.dataset.showShots === 'true') {
        this.updateRow(card, 'shots', [data.shotsCount]);
      }

      if (this.dataset.showBenefits === 'true') {
        this.updateRow(card, 'benefits', [data.usp1, data.usp2, data.usp3]);
      }

      if (this.dataset.showTageszeit === 'true') {
        this.updateRow(card, 'tageszeit', [data.tageszeit]);
      }

      if (this.dataset.showGeschmack === 'true') {
        this.updateRow(card, 'geschmack', [data.geschmack]);
      }

      if (this.dataset.showIngredients === 'true') {
        this.updateRow(card, 'ingredients', [data.ingredient1, data.ingredient2, data.ingredient3, data.ingredient4]);
      }
    }

    updateRow(card, rowKey, values) {
      const row = card.querySelector(`[data-row="${rowKey}"]`);
      if (!row) return;

      const container = row.querySelector('.bk-media-product-comparison__row-value');
      if (!container) return;

      if (rowKey === 'benefits') {
        const icons = [
          'https://cdn.shopify.com/s/files/1/0549/7546/3624/files/icons8-ziel-64.png?v=1718377092',
          'https://cdn.shopify.com/s/files/1/0549/7546/3624/files/icons8-naturkost-64.png?v=1718377092',
          'https://cdn.shopify.com/s/files/1/0549/7546/3624/files/icons8-offenes-buch-64.png?v=1718377092',
        ];
        container.innerHTML = (values || []).map((value, index) => {
          const text = value == null ? '' : String(value).trim();
          if (!text) {
            return '<div class="bk-media-comparison-grid__benefit-row"><p class="p">/</p></div>';
          }
          return `<div class="bk-media-comparison-grid__benefit-row"><img src="${icons[index]}" alt="" class="bk-media-comparison-grid__benefit-icon" width="100" height="100"><p class="p">${this.escapeHtml(text)}</p></div>`;
        }).join('') || '<p class="p">/</p>';
        return;
      }

      const items = (values || []).map((value) => {
        const text = value == null ? '' : String(value).trim();
        return text !== '' ? text : '/';
      });

      if (items.length === 0) {
        container.innerHTML = '<p class="p">/</p>';
        return;
      }

      container.innerHTML = items.map((value) => `<p class="p">${this.escapeHtml(value)}</p>`).join('');
    }

    updateButtons(blockId, data) {
      const buttonWraps = this.querySelectorAll(`.bk-media-product-comparison__desktop-column-header[data-block-id="${blockId}"] [data-comparison-button], .bk-media-product-comparison__mobile-product-header[data-block-id="${blockId}"] [data-comparison-button]`);

      buttonWraps.forEach((buttonWrap) => {
        const form = buttonWrap.querySelector('form');
        const input = buttonWrap.querySelector('[data-comparison-variant-input]');
        const submitButton = buttonWrap.querySelector('.button');

        if (form && data.handle) {
          form.action = `${window.Shopify?.routes?.root || '/'}products/${data.handle}`;
        }

        if (input) input.value = data.variantId;

        if (submitButton) {
          submitButton.disabled = data.buttonDisabled;
          submitButton.toggleAttribute('disabled', data.buttonDisabled);
          submitButton.setAttribute('aria-disabled', data.buttonDisabled ? 'true' : 'false');

          if (buttonWrap.dataset.comparisonButtonType === 'icon') {
            const srOnly = submitButton.querySelector('.sr-only');
            if (srOnly) srOnly.textContent = data.buttonText;
          } else {
            const textWrapper = submitButton.querySelector('.text-with-icon');
            if (textWrapper) {
              const textNodes = [...textWrapper.childNodes].filter((node) => node.nodeType === Node.TEXT_NODE || (node.nodeType === Node.ELEMENT_NODE && !node.matches('svg')));
              if (textNodes.length) {
                textNodes[0].textContent = data.buttonText;
              } else {
                textWrapper.append(document.createTextNode(data.buttonText));
              }
            } else {
              submitButton.textContent = data.buttonText;
            }
          }
        }
      });
    }

    escapeHtml(value) {
      return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    isVisibleComparisonSlot(element) {
      const slot = element.closest('.bk-media-product-comparison__column, .bk-media-product-comparison__mobile-product');
      return !slot || !slot.hidden;
    }

    syncRows() {
      this.querySelectorAll('[data-row]').forEach((row) => {
        row.style.minHeight = '';
        row.style.minWidth = '';
        row.style.width = '';
        row.style.flexBasis = '';

        if (row.classList.contains('bk-media-product-comparison__label-row')) {
          row.style.marginTop = '';
        }
      });

      const desktopLayout = this.querySelector('.bk-media-product-comparison__desktop');
      const mobileLayout = this.querySelector('.bk-media-product-comparison__mobile');

      if (desktopLayout && window.matchMedia('(min-width: 1000px)').matches) {
        this.syncDesktopRows(desktopLayout);
      }

      if (mobileLayout && window.matchMedia('(max-width: 999px)').matches) {
        this.syncMobileRows(mobileLayout);
      }
    }

    syncDesktopRows(layout) {
      const rowKeys = [...new Set([...layout.querySelectorAll('[data-row]')].map((el) => el.dataset.row))];
      const labelContainer = layout.querySelector('.bk-media-product-comparison__labels');
      const referenceColumn = this.getOrderedColumns().find((column) => !column.hidden);
      const referenceCard = referenceColumn?.querySelector('[data-comparison-card]');

      rowKeys.forEach((key) => {
        const rows = [...layout.querySelectorAll(`[data-row="${key}"]`)].filter((row) => {
          if (!this.isVisibleCriterionRow(row)) return false;
          if (row.classList.contains('bk-media-product-comparison__label-row')) return true;
          return this.isVisibleComparisonSlot(row);
        });
        let maxHeight = 0;

        rows.forEach((row) => {
          row.style.minHeight = '';
          maxHeight = Math.max(maxHeight, row.getBoundingClientRect().height);
        });

        rows.forEach((row) => {
          row.style.minHeight = `${Math.ceil(maxHeight)}px`;
        });
      });

      if (!labelContainer || !referenceCard) return;

      rowKeys.forEach((key) => {
        const labelRow = labelContainer.querySelector(`[data-row="${key}"]`);
        const productRow = referenceCard.querySelector(`[data-row="${key}"]`);
        if (!labelRow || !productRow || !this.isVisibleCriterionRow(labelRow) || !this.isVisibleCriterionRow(productRow)) return;

        const offset = productRow.getBoundingClientRect().top - labelRow.getBoundingClientRect().top;

        if (Math.abs(offset) >= 1) {
          labelRow.style.marginTop = `${Math.round(offset)}px`;
        }
      });
    }

    syncMobileRows(layout) {
      const track = layout.querySelector('.bk-media-product-comparison__mobile-unified-track');
      if (!track) return;

      track.querySelectorAll('.bk-media-product-comparison__mobile-bar-criteria-row, .bk-media-product-comparison__mobile-bar-values-row').forEach((element) => {
        element.style.width = '';
        element.style.minWidth = '';
        element.style.maxWidth = '';
        element.style.flexBasis = '';
      });

      const rowKeys = [...new Set([...track.querySelectorAll('[data-row]')].map((el) => el.dataset.row))];

      rowKeys.forEach((key) => {
        const cells = [...track.querySelectorAll(`[data-row="${key}"]`)].filter((cell) => this.isVisibleCriterionRow(cell) && this.isVisibleComparisonSlot(cell));
        const criteriaCells = [...track.querySelectorAll(`.bk-media-product-comparison__mobile-criteria-cell[data-row="${key}"]`)].filter((cell) => this.isVisibleCriterionRow(cell) && this.isVisibleComparisonSlot(cell));
        const valueCells = [...track.querySelectorAll(`.bk-media-product-comparison__mobile-cell[data-row="${key}"]`)].filter((cell) => this.isVisibleCriterionRow(cell) && this.isVisibleComparisonSlot(cell));
        let maxWidth = 0;

        cells.forEach((cell) => {
          cell.style.minHeight = '';
          cell.style.minWidth = '';
          cell.style.width = '';
          cell.style.flexBasis = '';
          maxWidth = Math.max(maxWidth, cell.getBoundingClientRect().width);
        });

        const syncedWidth = `${Math.ceil(maxWidth)}px`;

        cells.forEach((cell) => {
          cell.style.minWidth = syncedWidth;
          cell.style.width = syncedWidth;
          cell.style.flexBasis = syncedWidth;
        });

        const syncRowHeight = (rowCells) => {
          if (!rowCells.length) return;

          let maxHeight = 0;

          rowCells.forEach((cell) => {
            cell.style.minHeight = '';
            maxHeight = Math.max(maxHeight, cell.getBoundingClientRect().height);
          });

          rowCells.forEach((cell) => {
            cell.style.minHeight = `${Math.ceil(maxHeight)}px`;
          });
        };

        syncRowHeight(criteriaCells);
        syncRowHeight(valueCells);
      });

      const criteriaRows = [...track.querySelectorAll('.bk-media-product-comparison__mobile-bar-criteria-row')].filter((row) => this.isVisibleComparisonSlot(row));
      const valuesRows = [...track.querySelectorAll('.bk-media-product-comparison__mobile-bar-values-row')].filter((row) => this.isVisibleComparisonSlot(row));

      if (criteriaRows.length && valuesRows.length) {
        let maxTrackWidth = 0;

        criteriaRows.forEach((row) => {
          maxTrackWidth = Math.max(maxTrackWidth, row.getBoundingClientRect().width);
        });

        valuesRows.forEach((row) => {
          maxTrackWidth = Math.max(maxTrackWidth, row.getBoundingClientRect().width);
        });

        const syncedTrackWidth = `${Math.ceil(maxTrackWidth)}px`;

        criteriaRows.forEach((row) => {
          row.style.width = syncedTrackWidth;
        });

        valuesRows.forEach((row) => {
          row.style.width = syncedTrackWidth;
        });
      }
    }
  }

  customElements.define('bk-media-product-comparison', BkMediaProductComparison);
}

(function initComparisonBundlePrefill() {
  const storageKey = BK_MEDIA_COMPARISON_BUNDLE_STORAGE_KEY;

  function loadVariantIds() {
    let variantIds = [];

    try {
      const stored = sessionStorage.getItem(storageKey);
      if (stored) {
        variantIds = JSON.parse(stored);
      }
    } catch (error) {
      console.error('Failed to read comparison bundle variants:', error);
    }

    if (!Array.isArray(variantIds) || !variantIds.length) {
      const urlParam = new URLSearchParams(window.location.search).get('variants');
      if (urlParam) {
        variantIds = urlParam.split(',').map((value) => value.trim()).filter(Boolean);
      }
    }

    return variantIds;
  }

  function findPrefillSparsetBuilder() {
    let sectionId = '';

    try {
      sectionId = sessionStorage.getItem(BK_MEDIA_COMPARISON_SPARSET_SECTION_KEY) || '';
    } catch (error) {
      sectionId = '';
    }

    if (sectionId) {
      const section = document.getElementById(sectionId);
      const builderInSection = section?.querySelector('bk-media-sparset-builder');
      if (builderInSection) return builderInSection;
    }

    return document.querySelector('bk-media-sparset-builder');
  }

  function tryApplyPrefill() {
    const variantIds = loadVariantIds();
    if (!variantIds.length) return false;

    const builder = findPrefillSparsetBuilder();
    if (builder && typeof builder.bkMediaSetVariants === 'function') {
      builder.bkMediaSetVariants(variantIds, { replace: true, scroll: true });
      sessionStorage.removeItem(storageKey);
      sessionStorage.removeItem(BK_MEDIA_COMPARISON_SPARSET_SECTION_KEY);
      return true;
    }

    return false;
  }

  function schedulePrefillAttempts() {
    let attempts = 0;
    const maxAttempts = 40;

    const attempt = () => {
      if (tryApplyPrefill() || attempts >= maxAttempts) return;
      attempts += 1;
      window.setTimeout(attempt, 250);
    };

    attempt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedulePrefillAttempts, { once: true });
  } else {
    schedulePrefillAttempts();
  }
})();
